var PermissionResource;
(function (PermissionResource) {
  PermissionResource["HOME"] = "home";
  PermissionResource["HOME_ABANDONED_CHECKOUT"] = "home_abandoned_checkout";
  PermissionResource["SALES"] = "sales";
  PermissionResource["SUBSCRIPTIONS"] = "subscriptions";
  PermissionResource["SUBSCRIPTIONS_DEACTIVATE"] = "subscriptions_deactivate";
  PermissionResource["SUBSCRIPTIONS_ADD_DAILY_CREDITS"] = "subscriptions_add_daily_credits";
  PermissionResource["PRODUCTS"] = "products";
  PermissionResource["PRODUCTS_MANAGE_MEMBERS"] = "products_manage_members";
  PermissionResource["REPORTS"] = "reports";
  PermissionResource["MEMBERS"] = "members";
  PermissionResource["CLIENTS"] = "clients";
  PermissionResource["AFFILIATES"] = "affiliates";
  PermissionResource["COUPONS"] = "coupons";
  PermissionResource["REFUNDS"] = "refunds";
  PermissionResource["WALLET"] = "wallet";
  PermissionResource["INTEGRATIONS"] = "integrations";
  PermissionResource["PRODUCTS_MANAGE_CO_PRODUCTION"] = "products_manage_co_production";
  PermissionResource["PRODUCTS_MANAGE_POST_COMMENTS"] = "products_manage_post_comments";
})(PermissionResource || (PermissionResource = {}));

export { PermissionResource };
